import { useTranslation } from 'react-i18next';
import { Bell, BellOff } from 'lucide-react';
import { DropdownMenu } from '@/components/ui/DropdownMenu';
import { EmptyState } from '@/components/ui/EmptyState';

/**
 * Notification tray.
 *
 * Deliberately empty: the notifications module ships in a later phase, and inventing unread counts
 * in the header would misrepresent real activity to a user who cannot tell it is a mock. The
 * dashboard is where clearly-labelled demo data belongs.
 */
export function NotificationMenu() {
  const { t } = useTranslation();

  return (
    <DropdownMenu
      label={t('notifications.title')}
      triggerClassName="border-line text-muted hover:text-ink hover:bg-canvas border bg-white p-2"
      panelClassName="w-72"
      trigger={<Bell className="size-4" aria-hidden />}
    >
      {() => (
        <>
          <div className="border-line border-b px-4 py-2.5">
            <p className="text-ink text-sm font-medium">{t('notifications.title')}</p>
          </div>

          <EmptyState
            icon={BellOff}
            title={t('notifications.empty')}
            description={t('notifications.emptyHint')}
            className="px-4 py-8"
          />
        </>
      )}
    </DropdownMenu>
  );
}
